<template>
  <div>
    <div v-if="template==1" ref="crosswisePrint" id="tablePrints" class="crosswisePrint"
      style="border:1px solid #ccc;padding:2px;display:inline-block;padding-bottom:20px">
      <div style="text-align:center;font-size:18px;font-weight: bold;">{{hotel.name}}</div>
      <div style="text-align:center;font-size:18px;padding-top:10px">{{orderObj.description}}餐饮预付单</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="overflow:auto; width:100%; font-size:14px;margin-top:5px;padding-top:5px">
        <div style="float: left ;font-size:14px; width:45%;margin-bottom:5px">姓名:{{orderObj.cust_name}}</div>
        <div style="float: left ;font-size:14px;width:55%;margin-bottom:5px">名称:{{orderObj.book_name}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:14px;">
        <div style="float: left ;width:45%;">电话:{{orderObj.contact_tele}}</div>
        <div style="float: right;width:55%">单号:{{orderObj.order_num}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:14px;">
        <div style="float: left ;width:45%;">到达:{{orderObj.arriveTime}}</div>
        <div style="float: right;width:55%">时段:{{orderObj.mealDiffer}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:14px;">
        <div style="float: left ;width:45%;">餐厅:{{orderObj.outletsName}}</div>
        <div style="float: right;width:55%">桌号:{{orderObj.code}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:14px;">
        <div style="float: left ;width:45%;">桌数:{{orderObj.book_table_count}}</div>
        <div style="float: right;width:55%">人数:{{orderObj.people_count}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:14px;">
        <div style="float: left ;width:100%;">单位:{{orderObj.corp_name}}</div>

      </div>


      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length" />

      <div class="table" v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style=" width:100%;font-size:14px;font-weight:500">
        <div class="tableBody" style="">
          <div class="tabRow" style="display:flex;height:20px; width:100%">
            <div class="tabCol" style="display:flex;padding:0 5px; width:38% ;">
              菜品
            </div>
            <div class="tabCol" style=" width:16% ;text-align:right">
              数量
            </div>
            <div class="tabCol" style=" width:16% ; text-align:right">
              单位
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              价格
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              小计
            </div>
          </div>

          <div class="tabRow" style="display:flex;height:20px;width:100%;font-size:14px;font-weight:500"
            v-for="(tag,i) in orderObj.orderMenus" :key="i">
            <div class="tabCol"
              style="display:flex;width:40%;padding:0 5px; white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
              {{tag.discount_type == 'G' ? '[赠]':tag.discount_type == 'D' ? '[折]': ""}} {{tag.dishes_name}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{(tag.quantity * 1).toFixed(2)}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{tag.unit_name}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.price ? tag.price.toFixed(2) : '0.00'}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.total_price ? tag.total_price.toFixed(2) : '0.00'}}
            </div>
          </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="padding:10px 0px;display:flex;font-size:14px;justify-content: space-between;font-weight: bold;"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length">
        <div>菜金合计：</div>
        <div>{{(orderObj.order_total_price*1).toFixed(2)}}</div>
      </div>
      <hr v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div v-if="orderObj.bills && orderObj.bills.length">
        <div style="display:flex;font-size:14px;justify-content: space-between;">
          <div style="width:30%"> 付款项目 </div>
          <div style="width:20%"> 单号 </div>
          <div style="width:30%"> 收款日期 </div>
          <div style="width:15%"> 金额 </div>
        </div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

        <div style="display:flex;font-size:12px;justify-content: space-between; " v-for="(v,i) in orderObj.bills"
          :key='v.productName+i'>
          <div style="width:20%"> {{v.productName}} </div>
          <div style="width:25%"> {{v.bill_no}} </div>
          <div style="width:30%"> {{v.business_date}} </div>
          <div style="width:20%;text-align:right"> {{(v.totalPrice*1).toFixed(2)}} </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if="orderObj.bills && orderObj.bills.length" />

      <div v-if="orderObj.bills.length"
        style="padding:10px 0px;display:flex;font-size:14px;justify-content: space-between;font-weight: bold;">
        <div>预付合计</div>
        <div>{{orderObj.billprice ? orderObj.billprice : '0.00'}}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" v-if="orderObj.server_price " />
      <!-- <div style="text-align: left;font-weight: bold;font-size:12px">销售</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" /> -->
      <div style="display:flex;font-size:14px;justify-content: space-between;" v-if=" orderObj.order_discount ">
        <div style="padding:4px 0px;">折扣：</div>
        <div style="padding:4px 0px;">{{orderObj.order_discount}}</div>
      </div>
      <div style="display:flex;font-size:14px;justify-content: space-between;" v-if="orderObj.order_server_price ">
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">服务费：</div>
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">{{orderObj.order_server_price}}</div>
      </div>
      <div style="display:flex;font-size:14px;justify-content: space-between;" v-if=" orderObj.order_tax * 1 != 0 ">
        <div style="padding:4px 0px;">税额：</div>
        <div style="padding:4px 0px;">{{orderObj.order_tax}}</div>
      </div>
      <div style="padding:10px 0px;display:flex;font-size:14px;justify-content: space-between;font-weight: bold;"
        v-if="orderObj.order_all_price">
        <div>应收合计</div>
        <div>{{orderObj.order_all_price ? orderObj.order_all_price.toFixed(2) : '0.00'}}</div>
      </div>
      <hr v-if="orderObj.bills.length" style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="display:flex; flex-wrap:wrap; font-size:14px;">
        <div style="width:100%;margin-bottom:5px;;text-align:left">操作员:{{orderObj.user_name}}</div>
        <div style="width:100%;margin-bottom:5px;text-align:left">打印日期:{{gettime}}</div>
        <!-- <div style="width:100%;margin-bottom:5px">我同意支付以上费用</div> -->
        <!-- <div style="width:55%;margin-bottom:10px">服务员签名:</div>
        <div style="width:55%;margin-bottom:10px">经理签名:</div> -->
        <div style="width:55%;margin-bottom:10px">客人签名:</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
      <div style="font-size:14px;">地址：{{hotel.address}}</div>
      <div style="font-size:14px;">电话：{{hotel.tel}}</div>
      <div style="height:70px"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
    </div>
    <div v-if="template==2" ref="crosswisePrint" id="tablePrints" class="crosswisePrint"
      style="border:1px solid #ccc;padding:2px;display:inline-block;padding-bottom:20px">
      <div style="text-align:center;font-size:14px;font-weight: bold;">{{hotel.name}}</div>
      <div style="text-align:center;font-size:14px;padding-top:10px">{{orderObj.description}}餐饮预付单</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="overflow:auto; width:100%; font-size:10px;margin-top:5px;padding-top:5px">
        <div style="float: left ;font-size:10px; width:45%;margin-bottom:5px">姓名:{{orderObj.cust_name}}</div>
        <div style="float: left ;font-size:10px;width:55%;margin-bottom:5px">名称:{{orderObj.book_name}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:10px;">
        <div style="float: left ;width:45%;">电话:{{orderObj.contact_tele}}</div>
        <div style="float: right;width:55%">单号:{{orderObj.order_num}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:10px;">
        <div style="float: left ;width:45%;">到达:{{orderObj.arriveTime}}</div>
        <div style="float: right;width:55%">时段:{{orderObj.mealDiffer}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:10px;">
        <div style="float: left ;width:45%;">餐厅:{{orderObj.outletsName}}</div>
        <div style="float: right;width:55%">桌号:{{orderObj.code}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:10px;">
        <div style="float: left ;width:45%;">桌数:{{orderObj.book_table_count}}</div>
        <div style="float: right;width:55%">人数:{{orderObj.people_count}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:10px;">
        <div style="float: left ;width:100%;">单位:{{orderObj.corp_name}}</div>

      </div>


      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length" />

      <div class="table" v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style=" width:100%;font-size:10px;font-weight:500">
        <div class="tableBody" style="">
          <div class="tabRow" style="display:flex;height:20px; width:100%">
            <div class="tabCol" style="display:flex;padding:0 5px; width:38% ;">
              菜品
            </div>
            <div class="tabCol" style=" width:16% ;text-align:right">
              数量
            </div>
            <div class="tabCol" style=" width:16% ; text-align:right">
              单位
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              价格
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              小计
            </div>
          </div>

          <div class="tabRow" style="display:flex;height:20px;width:100%;font-size:10px;font-weight:500"
            v-for="(tag,i) in orderObj.orderMenus" :key="i">
            <div class="tabCol"
              style="display:flex;width:40%;padding:0 5px; white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
              {{tag.discount_type == 'G' ? '[赠]':tag.discount_type == 'D' ? '[折]': ""}} {{tag.dishes_name}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{(tag.quantity * 1).toFixed(2)}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{tag.unit_name}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.price ? tag.price.toFixed(2) : '0.00'}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.total_price ? tag.total_price.toFixed(2) : '0.00'}}
            </div>
          </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="padding:10px 0px;display:flex;font-size:10px;justify-content: space-between;font-weight: bold;"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length">
        <div>菜金合计：</div>
        <div>{{(orderObj.order_total_price*1).toFixed(2)}}</div>
      </div>
      <hr v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div v-if="orderObj.bills && orderObj.bills.length">
        <div style="display:flex;font-size:10px;justify-content: space-between;">
          <div style="width:30%"> 付款项目 </div>
          <div style="width:20%"> 单号 </div>
          <div style="width:30%"> 收款日期 </div>
          <div style="width:15%"> 金额 </div>
        </div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

        <div style="display:flex;font-size:10px;justify-content: space-between; " v-for="(v,i) in orderObj.bills"
          :key='v.productName+i'>
          <div style="width:26%"> {{v.productName}} </div>
          <div style="width:28%"> {{v.bill_no}} </div>
          <div style="width:25%;text-align:right"> {{v.business_date}} </div>
          <div style="width:18%;text-align:right"> {{(v.totalPrice*1).toFixed(2)}} </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if="orderObj.bills && orderObj.bills.length" />

      <div v-if="orderObj.bills.length"
        style="padding:10px 0px;display:flex;font-size:10px;justify-content: space-between;font-weight: bold;">
        <div>预付合计</div>
        <div>{{orderObj.billprice ? orderObj.billprice : '0.00'}}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" v-if="orderObj.server_price " />
      <!-- <div style="text-align: left;font-weight: bold;font-size:10px">销售</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" /> -->
      <div style="display:flex;font-size:10px;justify-content: space-between;" v-if=" orderObj.order_discount ">
        <div style="padding:4px 0px;">折扣：</div>
        <div style="padding:4px 0px;">{{orderObj.order_discount}}</div>
      </div>
      <div style="display:flex;font-size:10px;justify-content: space-between;" v-if="orderObj.order_server_price ">
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">服务费：</div>
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">{{orderObj.order_server_price}}</div>
      </div>
      <div style="display:flex;font-size:10px;justify-content: space-between;" v-if=" orderObj.order_tax * 1 != 0 ">
        <div style="padding:4px 0px;">税额：</div>
        <div style="padding:4px 0px;">{{orderObj.order_tax}}</div>
      </div>
      <div style="padding:10px 0px;display:flex;font-size:10px;justify-content: space-between;font-weight: bold;"
        v-if="orderObj.order_all_price">
        <div>应收合计</div>
        <div>{{orderObj.order_all_price ? orderObj.order_all_price.toFixed(2) : '0.00'}}</div>
      </div>
      <hr v-if="orderObj.bills.length" style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="display:flex; flex-wrap:wrap; font-size:10px;">
        <div style="width:100%;margin-bottom:5px;;text-align:left">操作员:{{user.name}}</div>
        <div style="width:100%;margin-bottom:5px;text-align:left">打印日期:{{gettime}}</div>
        <!-- <div style="width:100%;margin-bottom:5px">我同意支付以上费用</div> -->
        <!-- <div style="width:55%;margin-bottom:10px">服务员签名:</div>
        <div style="width:55%;margin-bottom:10px">经理签名:</div> -->
        <div style="width:55%;margin-bottom:10px">客人签名:</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
      <div style="font-size:10px;">地址：{{hotel.address}}</div>
      <div style="font-size:10px;">电话：{{hotel.tel}}</div>
      <div style="height:70px"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
    </div>
    <div v-if="template==3" ref="crosswisePrint" id="tablePrints" class="crosswisePrint"
      style="border:1px solid #ccc;padding:2px;display:inline-block;padding-bottom:20px">
      <div style="text-align:center;font-size:24px;font-weight: bold;">{{hotel.name}}</div>
      <div style="text-align:center;font-size:24px;padding-top:10px">{{orderObj.description}}餐饮预付单</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="overflow:auto; width:100%; font-size:18px;margin-top:5px;padding-top:5px">
        <div style="float: left ;font-size:18px; width:45%;margin-bottom:5px">姓名:{{orderObj.cust_name}}</div>
        <div style="float: left ;font-size:18px;width:55%;margin-bottom:5px">名称:{{orderObj.book_name}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:18px;">
        <div style="float: left ;width:45%;">电话:{{orderObj.contact_tele}}</div>
        <div style="float: right;width:55%">单号:{{orderObj.order_num}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:18px;">
        <div style="float: left ;width:45%;">到达:{{orderObj.arriveTime}}</div>
        <div style="float: right;width:55%">时段:{{orderObj.mealDiffer}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:18px;">
        <div style="float: left ;width:45%;">餐厅:{{orderObj.outletsName}}</div>
        <div style="float: right;width:55%">桌号:{{orderObj.code}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:18px;">
        <div style="float: left ;width:45%;">桌数:{{orderObj.book_table_count}}</div>
        <div style="float: right;width:55%">人数:{{orderObj.people_count}}</div>
      </div>
      <div style="overflow:auto; width:100%; font-size:18px;">
        <div style="float: left ;width:100%;">单位:{{orderObj.corp_name}}</div>

      </div>


      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length" />

      <div class="table" v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style=" width:100%;font-size:18px;font-weight:500">
        <div class="tableBody" style="">
          <div class="tabRow" style="display:flex;height:20px; width:100%">
            <div class="tabCol" style="display:flex;padding:0 5px; width:38% ;">
              菜品
            </div>
            <div class="tabCol" style=" width:16% ;text-align:right">
              数量
            </div>
            <div class="tabCol" style=" width:16% ; text-align:right">
              单位
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              价格
            </div>
            <div class="tabCol" style=" width:20% ;text-align:right">
              小计
            </div>
          </div>

          <div class="tabRow" style="display:flex;height:20px;width:100%;font-size:18px;font-weight:500"
            v-for="(tag,i) in orderObj.orderMenus" :key="i">
            <div class="tabCol"
              style="display:flex;width:40%;padding:0 5px; white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
              {{tag.discount_type == 'G' ? '[赠]':tag.discount_type == 'D' ? '[折]': ""}} {{tag.dishes_name}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{(tag.quantity * 1).toFixed(2)}}
            </div>
            <div class="tabCol" style="width:15%;text-align:right">
              {{tag.unit_name}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.price ? tag.price.toFixed(2) : '0.00'}}
            </div>
            <div class="tabCol" style="width:20%;text-align:right">
              {{tag.total_price ? tag.total_price.toFixed(2) : '0.00'}}
            </div>
          </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="padding:10px 0px;display:flex;font-size:18px;justify-content: space-between;font-weight: bold;"
        v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length">
        <div>菜金合计：</div>
        <div>{{(orderObj.order_total_price*1).toFixed(2)}}</div>
      </div>
      <hr v-if=" orderObj.orderMenus &&  orderObj.orderMenus.length"
        style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div v-if="orderObj.bills && orderObj.bills.length">
        <div style="display:flex;font-size:18px;justify-content: space-between;">
          <div style="width:30%"> 付款项目 </div>
          <div style="width:20%"> 单号 </div>
          <div style="width:30%"> 收款日期 </div>
          <div style="width:15%"> 金额 </div>
        </div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

        <div style="display:flex;font-size:18px;justify-content: space-between; " v-for="(v,i) in orderObj.bills"
          :key='v.productName+i'>
          <div style="width:20%"> {{v.productName}} </div>
          <div style="width:25%"> {{v.bill_no}} </div>
          <div style="width:30%"> {{v.business_date}} </div>
          <div style="width:20%"> {{(v.totalPrice*1).toFixed(2)}} </div>
        </div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px"
        v-if="orderObj.bills && orderObj.bills.length" />

      <div v-if="orderObj.bills.length"
        style="padding:10px 0px;display:flex;font-size:18px;justify-content: space-between;font-weight: bold;">
        <div>预付合计</div>
        <div>{{orderObj.billprice ? orderObj.billprice : '0.00'}}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" v-if="orderObj.server_price " />
      <!-- <div style="text-align: left;font-weight: bold;font-size:12px">销售</div>
    <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" /> -->
      <div style="display:flex;font-size:18px;justify-content: space-between;" v-if=" orderObj.order_discount ">
        <div style="padding:4px 0px;">折扣：</div>
        <div style="padding:4px 0px;">{{orderObj.order_discount}}</div>
      </div>
      <div style="display:flex;font-size:18px;justify-content: space-between;" v-if="orderObj.order_server_price ">
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">服务费：</div>
        <div style="padding:4px 0px;" v-if="orderObj.order_server_price ">{{orderObj.order_server_price}}</div>
      </div>
      <div style="display:flex;font-size:18px;justify-content: space-between;" v-if=" orderObj.order_tax * 1 != 0 ">
        <div style="padding:4px 0px;">税额：</div>
        <div style="padding:4px 0px;">{{orderObj.order_tax}}</div>
      </div>
      <div style="padding:10px 0px;display:flex;font-size:18px;justify-content: space-between;font-weight: bold;"
        v-if="orderObj.order_all_price">
        <div>应收合计</div>
        <div>{{orderObj.order_all_price ? orderObj.order_all_price.toFixed(2) : '0.00'}}</div>
      </div>
      <hr v-if="orderObj.bills.length" style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div style="display:flex; flex-wrap:wrap; font-size:18px;">
        <div style="width:100%;margin-bottom:5px;;text-align:left">操作员:{{orderObj.user_name}}</div>
        <div style="width:100%;margin-bottom:5px;text-align:left">打印日期:{{gettime}}</div>
        <!-- <div style="width:100%;margin-bottom:5px">我同意支付以上费用</div> -->
        <!-- <div style="width:55%;margin-bottom:10px">服务员签名:</div>
        <div style="width:55%;margin-bottom:10px">经理签名:</div> -->
        <div style="width:55%;margin-bottom:10px">客人签名:</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
      <div style="font-size:18px;">地址：{{hotel.address}}</div>
      <div style="font-size:18px;">电话：{{hotel.tel}}</div>
      <div style="height:70px"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px;" />
    </div>




  </div>
</template>
<script>
  import getLodop from '@/utils/Lodopfuncs'

  export default {
    props: {
      orderObj: {
        type: Object
      },
    },
    data() {
      return {
        hotleInfo: {},
        listQuery: {},
        employee: {},
        handleClose: {},
        shiftCodeFilter: '',
        user: {},
        tableHeadData: [{
            id: 1,
            name: "菜品"
          },
          {
            id: 1,
            name: "数量"
          },
          {
            id: 1,
            name: "单位"
          },
          {
            id: 1,
            name: "价格"
          },
          {
            id: 1,
            name: "小计"
          }
        ],
        gettime: '',
        tableBodyData: [],
        printnameB: "清餐划菜",
        hotel: JSON.parse(localStorage.getItem('hotel')),
        user: JSON.parse(localStorage.getItem('user')),
        flag: false,
        template: 1
      }
    },
    watch: {

    },
    created() {
      this.getCurrentTime()

    },
    beforeDestroy() {

    },
    mounted() {
      this.$bus.$on('printName', val => {
        this.printnameB = val
      })
      this.$bus.$on('printobj', val => {
        this.orderObj = val
      })

     
    },
    methods: {

      getCurrentTime() {

        var _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
        _this.gettime = yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss;

        let url = this.api.getByDocuments + '?name=pos打印'
        let methods = 'get'
        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status == 0 && res.data.data) {


            url = this.api.hotelTemplate + '?printClassifyId=' + res.data.data[1].id
            this.$axios({
              url,
              methods
            }).then(e => {
              if (e.data.status == 0 && e.data.data) {
                switch (e.data.data.name) {
                  case '标准模板':
                    this.template = 1
                    break;
                  case '太阳城':
                    this.template = 2
                    break;
                  case '友谊峰':
                    this.template = 3
                    break;


                }

              }
            })
          }
        })
      },
      deleteClick(id) {
        this.tableBodyData.splice(id, 1);
      },
      getData(val) {
        this.listQuery = Object.assign({}, val)
        this.getInit()
      },
      getInit() {
        payTypeTotal(this.listQuery).then(res => {
          if (res.data.status == 0) {
            this.reportDateTotalSum = 0
            this.payTypeTotalSum = 0
            this.reportDateTotal = res.data.data && res.data.data.reportDateTotal.length > 0 ? res.data.data
              .reportDateTotal : []
            this.payTypeTotal = res.data.data && res.data.data.payTypeTotal.length > 0 ? res.data.data
              .payTypeTotal : []
            this.reportDateTotal.map(v => {
              this.reportDateTotalSum += v.total_price ? v.total_price : 0
            })
            this.payTypeTotal.map(v => {
              this.payTypeTotalSum += v.total_price ? v.total_price : 0
            })
          }
        })
      },
      getlist() {
        console.log('打印任务1');
        this.getCurrentTime()
        if (this.orderObj.code) {

          this.$nextTick(() => {
            this.todoPrint()
          })
        } else {
          setTimeout(() => {
            this.getlist()
          }, 500);
        }

      },

      GetPrinter() {
        //获取当前打印机

        LODOP = getLodop();

        var iCount = LODOP.GET_PRINTER_COUNT();

        var PData = [];

        for (var i = 0; i < iCount; i++) {
          PData.push(LODOP.GET_PRINTER_NAME(i));
        }

        return PData;
      },
      todoPrint(type) {
        console.log('打印',this.printnameB);
        const LODOP = getLodop()

        if (LODOP) {
          //获取打印内容
          var strFormHtml = `<body>` + document.getElementById('tablePrints').innerHTML + '</body>' //获取打印内容
          // var strFormHtml = `<body>` + document.getElementById('tablePrintsBig').innerHTML + '</body>' //获取打印内容


          LODOP.PRINT_INIT('') //初始化
          // LODOP.SET_PRINT_PAGESIZE(1, 60, 0, '') //设置纵向
          // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
          if (this.template == 3) {
            LODOP.SET_PRINT_PAGESIZE(1, '140mm', '240mm');
          }
          LODOP.ADD_PRINT_HTM('30', '4', '100%', '90%', strFormHtml)
          // LODOP.SET_PRINT_STYLEA(0, "Offset2Top", 10)
          // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
          // LODOP.SET_PRINT_STYLEA(0, "TextNeatRow", true)
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 800, '') //设置预览窗口模式和大小
          LODOP.SET_PRINT_MODE("NOCLEAR_AFTER_PRINT", true); //设置打印完毕不清理打印信息

          var PData = this.GetPrinter();


          if (PData.length) {

            if (type === 'preview') {
              LODOP.SET_PRINTER_INDEXA(this.printnameB); //设置某个打印机
              LODOP.PREVIEW();
            } else {
              if (PData.indexOf(this.printnameB) !== -1) {
                LODOP.SET_PRINTER_INDEXA(this.printnameB); //设置某个打印机
                LODOP.PRINT()

              }


            }
          }
        }
      },

    }
  }
</script>
<style scoped>
  .crosswisePrint {
    width: 430px;
    margin-top: 20px;
  }

  .box {
    width: 100px;
    height: 40px;
    border: 1px solid #eee;
    border-radius: 10px;
    line-height: 40px;
    text-align: center;


  }
</style>